<template>
    <div class="container__grid">
        <span class="helper__tooltip purple">
            <h3 class="label_title_gains" :style="'color:' + (this.view.color ? this.view.color : 'black')" v-html="t.type_token"></h3>
            <span class="helper__tooltip--text" style="width: 300px;" v-html="t.tooltip_type_token"></span>
        </span>
        <input type="text" class="form-control" id="token__number" name="token__number" maxlength="6" required>
        <a style="font-size: 13px;" :href="routeUser">{{t.want_disable_token}}</a>
    </div>
</template>

<script>
// HOW TO USE

// 1 - add the snippet in the html
// <div id="app__2fa">
//     <handle-token-2fa></handle-token-2fa>
// </div>

// get the item with id = #token__number OR name = token__number and use the value in your request form

export default {
    name: "handle-token-2fa",
    props: ["view"],
    data() {
        return {
            t: window.__env.translate.token_2fa,
            routeUser: window.__env.route_edit_user + '?type_token=disable'
        };
    },
    methods: {
    },
    
    mounted() {
        console.log('====================================');
        console.log(window.__env.route_edit_user);
        console.log('====================================');
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @import "../../../scss/office";
</style>


// WEBPACK FOOTER //
// resources/office/js/components/token-2fa/handle-token.vue